

export const frontMatter = {
	authors: [
		'noomorph',
		'jvs'
	]
};
export const contentTitle = 'Асиметрија меджу LJ/NJ и Љ/Њ';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-blog/default/site-articles-2024-07-09-diskusija-lj-nj-cyrl-md-439.json'
export const assets = {
"authorsImageUrls": [undefined, undefined],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Мотивација",
  "id": "мотивација",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "мотивација",
      children: "Мотивација"
    }), "\n", _jsxs(_components.p, {
      children: ["Уж нєколико седмиц Јан ван Стеенберген јест много зајеты с прєводжењем вики-интерфејса, да быхмо могли потом спокојно почети работу над МС Википедијеју. То јест спєшно дєло, ибо кратко послє публикације нашего кода ", _jsx(_components.code, {
        children: "ISO 639-3"
      }), " уже појавило се прєдложење за МС Википедију МС пројект в Инкубатору. Не хочемо, абы људи почели копијовати тексты из Меджувики, что јест нарушење авторскых прав. Вмєсто того, трєба буде копирати цєло содржање Меджувики в Инкубатор – заједно с хисторијеју. В Меджувики јест автоматичны транслитератор, да бы читатељи могли избирати меджу латиницеју и кирилицеју. Очевидно, в Википедији он такоже буде потрєбны. Ту јест једин малы проблем."]
    }), "\n", _jsxs(_components.p, {
      children: ["Тутдењ меджусловјанскы правопис имаје асиметрију меджу латиницеју и кирилицеју, что се тыче прєдавања диграфов ", _jsx(_components.code, {
        children: "lj"
      }), " и ", _jsx(_components.code, {
        children: "nj"
      }), " на писму, и то јест објект нашеј дискусије ниже."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

